<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  metaInfo() {
    const param = this.$route.query
    return {
      htmlAttrs: {
        lang: param.lang ? param.lang : 'zh-CN',
      },
    }
  }
}
</script>
<style lang="scss"></style>